import { render } from "./workInfo.vue?vue&type=template&id=2eb278f4&scoped=true"
import script from "./workInfo.vue?vue&type=script&lang=js"
export * from "./workInfo.vue?vue&type=script&lang=js"

import "./workInfo.vue?vue&type=style&index=0&id=2eb278f4&lang=less&scoped=true"

import exportComponent from "D:\\workday\\code\\h5-moxigecash\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eb278f4"]])

export default __exports__